import { Link } from "react-router-dom";
import FacebookIcon from "../../../img/svg/facebookIcon";
import InstagramIcon from "../../../img/svg/instagramIcon";
import YoutubeIcon from "../../../img/svg/youtubeIcon";
import MailIcon from "../../../img/svg/mailIcon";
import gioia from "../../../img/gioia.png";
import GMTIcon from "../../../img/svg/gmtIcon";
// import PhoneIcon from "../../../img/svg/phoneIcon";
// import WhatsappIcon from "../../../img/svg/whatsappIcon";

export default function Footer() {
    return (
        <footer className="bg-primary text-mono p-10 pt-20 pb-12 relative overflow-hidden">
            <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-16 relative z-10">
                {/* Navigation Links */}
                <div className="flex flex-col gap-4 text-center md:text-left">
                    <h4 className="text-white font-black tracking-[0.2em] text-xs uppercase mb-2">Navegação</h4>
                    <div className="flex flex-col gap-3">
                        {[
                            { name: "Relógios", path: "/watches" },
                            { name: "Sobre o GMT-3", path: "/about" },
                            { name: "Guia de Compra Segura", path: "/safe-buying" },
                            { name: "Dúvidas Frequentes", path: "/faq" }
                        ].map((link) => (
                            <Link
                                key={link.path}
                                to={link.path}
                                className="text-sm hover:text-secondary transition-colors duration-300 w-fit mx-auto md:mx-0"
                            >
                                {link.name}
                            </Link>
                        ))}
                    </div>
                </div>

                {/* Social Media */}
                <div className="text-center space-y-6">
                    <h4 className="text-white font-black tracking-[0.2em] text-xs uppercase">Siga nossa jornada</h4>
                    <div className="flex items-center justify-center gap-8">
                        <Link to="https://facebook.com/gmtmenos3" target="_blank" className="hover:scale-110 transition-transform text-mono hover:text-[#1877F2]">
                            <FacebookIcon fill="currentColor" />
                        </Link>
                        <Link to="https://youtube.com.br/gmtmenos3" target="_blank" className="hover:scale-110 transition-transform text-mono hover:text-[#FF0000]">
                            <YoutubeIcon fill="currentColor" />
                        </Link>
                        <Link to="https://instagram.com/gmtmenos3" target="_blank" className="hover:scale-110 transition-transform text-mono hover:text-[#E4405F]">
                            <InstagramIcon fill="currentColor" />
                        </Link>
                    </div>
                    <div className="pt-4 scale-75 md:scale-90 opacity-40 grayscale group-hover:grayscale-0 transition-all duration-700 flex items-center justify-center">
                        <GMTIcon fill="white" width="120px" />
                    </div>
                </div>

                {/* Contact Info */}
                <div className="text-center md:text-right space-y-6">
                    <h4 className="text-white font-black tracking-[0.2em] text-xs uppercase">Contato</h4>
                    <div className="flex flex-col gap-4 items-center md:items-end">
                        <Link
                            target="_blank"
                            to="mailto:contato@gmtmenos3.com.br"
                            className="flex items-center gap-3 text-sm hover:text-secondary transition-colors group"
                        >
                            <span className="order-2 md:order-1">contato@gmtmenos3.com.br</span>
                            <div className="p-2 bg-white/5 rounded-full group-hover:bg-secondary/20 order-1 md:order-2 transition-colors">
                                <MailIcon fill="currentColor" />
                            </div>
                        </Link>
                    </div>
                </div>
            </div>

            {/* Bottom Bar */}
            <div className="max-w-7xl mx-auto mt-20 pt-8 border-t border-white/5 flex flex-col md:flex-row justify-between items-center gap-6">
                <p className="text-[10px] tracking-widest uppercase">
                    © {new Date().getFullYear()} GMT Menos 3 - Todos os direitos reservados
                </p>
                <div className="w-20 opacity-30 hover:opacity-100 transition-opacity">
                    <a href="https://gioiaperformance.com/" target="_blank" rel="noreferrer">
                        <img src={gioia} alt="gioia performance" className="w-full" />
                    </a>
                </div>
            </div>

            {/* Background Accent */}
            <div className="absolute top-0 right-0 w-[300px] h-[300px] bg-secondary/5 rounded-full blur-[120px] -translate-y-1/2 translate-x-1/2" />
        </footer>
    )
}

